import React from 'react';
import style from './style.module.scss';
import { AcvtGame, AcvtSupportedLanguages } from '../../../../types/acvt';
import { useT, usePreview } from '../../../preview';
import { formatDate } from '~utils/format';

type GameCard = {
    gameObject: AcvtGame;
    /**
     * Kept for backward compatibility — the active language now comes
     * from `usePreview()` and labels from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    opened: React.Dispatch<
        React.SetStateAction<{
            homePromoCard: boolean;
            homeGameCard: boolean;
            promoCard: boolean;
            gameCard: boolean;
        }>
    >;
    setSingleGame: (promo: AcvtGame) => void;
};

export const AcvtGameCard = ({
    gameObject,
    opened,
    setSingleGame,
}: GameCard) => {
    const t = useT();
    const { language } = usePreview();
    const setGame = () => {
        setSingleGame(gameObject);
    };

    return (
        <>
            <div className={style.container}>
                <div
                    className={style.card}
                    onClick={() => {
                        opened((prevState) => {
                            return { ...prevState, gameCard: true };
                        });
                        setGame();
                    }}
                >
                    <div className={style.image}>
                        <img
                            alt=""
                            src={
                                gameObject?.image[
                                    language as AcvtSupportedLanguages
                                ] ?? ''
                            }
                        />
                    </div>
                    <div className={style.text_grid}>
                        <div className={style.title}>
                            {
                                gameObject?.title[
                                    language as AcvtSupportedLanguages
                                ]
                            }
                        </div>
                        <div className={style.subtitle}>
                            {
                                gameObject?.subTitle[
                                    language as AcvtSupportedLanguages
                                ]
                            }
                        </div>
                        <div className={style.dates}>
                            {`${t.games.fromDateStart}${formatDate(
                                gameObject?.startDate,
                                language
                            )}${t.games.fromDateJoin}${formatDate(
                                gameObject?.endDate,
                                language
                            )}`}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
